<div class="comentario-modal-backdrop" *ngIf="isOpen" (click)="onBackdropClick()"></div>

<div class="comentario-modal" *ngIf="isOpen" role="dialog" aria-modal="true" aria-labelledby="comentario-modal-title">
  <div class="comentario-modal__header">
    <h3 id="comentario-modal-title" class="comentario-modal__title">{{ title }}</h3>
    <button type="button" class="comentario-modal__add" (click)="addCampoCustom()" aria-label="Adicionar novo campo">+</button>
  </div>

  <div class="comentario-modal__body">
    <div class="comentario-modal__field" *ngFor="let campo of campos; let i = index">
      <label class="comentario-modal__label" [attr.for]="'campo-key-' + i">{{ campo.isCustom ? 'Nova chave' : campo.key }}</label>

      <input
        *ngIf="campo.isCustom"
        [id]="'campo-key-' + i"
        type="text"
        class="comentario-modal__input"
        [(ngModel)]="campo.key"
        placeholder="Informe a chave" />

      <textarea
        [id]="'campo-value-' + i"
        class="comentario-modal__textarea"
        rows="3"
        [(ngModel)]="campo.value"
        [placeholder]="campo.isCustom ? 'Digite o valor para a nova chave' : 'Digite o valor deste campo'">
      </textarea>
    </div>
  </div>

  <div class="comentario-modal__actions">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="onSave()">Salvar</button>
  </div>
</div>